import { DocumentIsogd } from "isogd-document-rest";

class DocumentSpecificViewController {
    private document: DocumentIsogd;
}

export const DocumentSpecificViewComponent: angular.IComponentOptions = {
    controller: DocumentSpecificViewController,
    template: require('./documentSpecificView.html'),
    bindings: {
        document: "<"
    }
};


// WEBPACK FOOTER //
// ./src/components/document/document-specific/documentSpecificView.ts